"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var validation_1 = require("../../validation");

var builder_1 = require("../../builder");

var BuiltInPartsKeys;

(function (BuiltInPartsKeys) {
  BuiltInPartsKeys["PaperTowelDispensers"] = "paperTowelDispensers";
  BuiltInPartsKeys["PaperTowelDispensersPosition"] = "paperTowelDispensersPosition";
  BuiltInPartsKeys["SoapDispenserHole"] = "soapDispenserHole";
  BuiltInPartsKeys["SoapDispenserHolePositions"] = "soapDispenserHolePositions";
  BuiltInPartsKeys["TapHole"] = "tapHole";
  BuiltInPartsKeys["TapHolePositions"] = "tapHolePositions";
  BuiltInPartsKeys["TissueDispenser"] = "tissueDispenser";
  BuiltInPartsKeys["TissueDispenserPosition"] = "tissueDispenserPosition";
  BuiltInPartsKeys["TowelRail"] = "towelRail";
  BuiltInPartsKeys["TowelRailPosition"] = "towelRailPosition";
  BuiltInPartsKeys["cutOutDisposals"] = "cutOutDisposals";
  BuiltInPartsKeys["cutOutDisposalsType"] = "cutOutDisposalsType";
  BuiltInPartsKeys["cutOutDisposalsPosition"] = "cutOutDisposalsPosition";
  BuiltInPartsKeys["cutOutDisposalsCustomSettings"] = "cutOutDisposalsCustomSettings";
  BuiltInPartsKeys["cutOutDisposalsApronRequired"] = "cutOutDisposalsApronRequired";
})(BuiltInPartsKeys = exports.BuiltInPartsKeys || (exports.BuiltInPartsKeys = {}));

var BuiltInParts =
/** @class */
function (_super) {
  __extends(BuiltInParts, _super);

  function BuiltInParts() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BuiltInParts.prototype.handle = function () {
    var _this = this;

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(BuiltInPartsKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[BuiltInPartsKeys[key]] = _this[BuiltInPartsKeys[key]], _a));
    });
    return data;
  };

  BuiltInParts.prototype.handleDefaults = function () {
    var defaults = this.default;
    var data = this.handle(); // No more cutOutDisposalsType... I will leave it in, because it has the array of all cut-out types xP
    // defaults.cutOutDisposalsPosition && defaults.paperTowelDispensersPosition now has spacings which I can use on the front-end if I need to...

    if (data) {
      if (this.tapHoleDefaults) {
        defaults = this.tapHoleDefaults(defaults) || defaults;

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }

      if (this.soapDispenserDefaults) {
        defaults = this.soapDispenserDefaults(defaults) || defaults;

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }

      var plateBuilder = this.trough && new builder_1.PlateBuilder(this, this.trough);

      if (!plateBuilder) {
        return;
      } // Cut outs...


      if (data && data.cutOutDisposals) {
        var preparedCutOutPositions = validation_1.prepareCutOutPositions({
          partPositions: data.cutOutDisposalsPosition || [false],
          qty: this.qty,
          prevQty: this.prevQty
        });
        defaults.cutOutDisposalsPosition = lodash_1.assign({}, defaults.cutOutDisposalsPosition, {
          values: preparedCutOutPositions && preparedCutOutPositions.values || []
        }); // Cutout at each position...

        defaults = validation_1.validateCutOutDisposalsPosition(data, defaults, this.assemblyAccessories && this.assemblyAccessories.console, this.apronBackSplash, plateBuilder, this);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        } // Dropdown options for each position...


        defaults = validation_1.validateCutOutDisposalsType(data, defaults, this.assemblyAccessories && this.assemblyAccessories.console, plateBuilder, this.apronBackSplash && this.apronBackSplash.apronHeight || 0, this);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        } // Custom options for each position...


        defaults = validation_1.validateCutOutCustomSettings(data, defaults, this.assemblyAccessories && this.assemblyAccessories.console, plateBuilder, this.apronBackSplash && this.apronBackSplash.apronHeight || 0);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        } // Next I need to make sure the spacings value is populate and pushed to front-end...
        // Then using that I can limit the cutouts... 
        // After that I can show/hide fields, and on change post the array value
        // After that I can validate it here...
        // defaults = validateCutOutCustomSettings(
        //   data,
        //   defaults as BuiltInPartsDefaultModel,
        //   this.assemblyAccessories && this.assemblyAccessories.console,
        //   plateBuilder,
        //   this.apronBackSplash && this.apronBackSplash.apronHeight || 0
        // );


        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      } // Paper towels...


      if (data && data.tissueDispenser) {
        var preparePaperTowelDispensersPosition = validation_1.prepareBooleanPositions({
          partPositions: data.paperTowelDispensersPosition || [false],
          qty: this.qty,
          prevQty: this.prevQty
        });
        defaults.paperTowelDispensersPosition = lodash_1.assign({}, defaults.paperTowelDispensersPosition, {
          values: preparePaperTowelDispensersPosition && preparePaperTowelDispensersPosition.values || []
        });
        defaults = validation_1.validatePaperTowelDispensersPosition(data, defaults, this.assemblyAccessories && this.assemblyAccessories.console, plateBuilder, this.apronBackSplash && this.apronBackSplash.apronHeight || 0, this);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      } // Tissue dispensers


      if (data && data.tissueDispenser) {
        var prepareTissueDispenserPosition = validation_1.prepareBooleanPositions({
          partPositions: data.tissueDispenserPosition || [false],
          qty: this.qty,
          prevQty: this.prevQty
        });
        defaults.tissueDispenserPosition = lodash_1.assign({}, defaults.tissueDispenserPosition, {
          values: prepareTissueDispenserPosition && prepareTissueDispenserPosition.values || []
        });
        defaults = validation_1.validateTissueDispenserPosition(data, defaults, this.assemblyAccessories && this.assemblyAccessories.console, plateBuilder, this.apronBackSplash && this.apronBackSplash.apronHeight || 0);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }
    }

    return defaults;
  };

  Object.defineProperty(BuiltInParts.prototype, "cutOutDisposals", {
    get: function get() {
      if (!this.builtInParts) {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.cutOutDisposals).default;
      }

      return this.reset ? false : this.builtInParts.cutOutDisposals;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "cutOutDisposalsPosition", {
    get: function get() {
      if (!this.builtInParts || this.builtInParts && !this.cutOutDisposals || this.builtInParts && !this.cutOutDisposalsType || this.reset) {
        return null;
      }

      var cutOutDisposalsPosition = validation_1.prepareCutOutPositions({
        partPositions: this.builtInParts && this.builtInParts.cutOutDisposalsPosition && this.builtInParts.cutOutDisposalsPosition.length > 0 ? this.builtInParts.cutOutDisposalsPosition : [false],
        qty: this.qty,
        prevQty: this.prevQty
      });
      var positions = cutOutDisposalsPosition.positions || null;
      return positions || cutOutDisposalsPosition.values;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "cutOutDisposalsCustomSettings", {
    get: function get() {
      if (!this.builtInParts || this.builtInParts && !this.cutOutDisposals || this.builtInParts && !this.cutOutDisposalsType || this.reset) {
        return null;
      } // Difficult to set here? I think it's okay actually... we say it's 135/162, and thething reflects that below


      if (!this.builtInParts.cutOutDisposalsCustomSettings) {
        if (this.builtInParts.cutOutDisposalsType === 'CUSTOM_ROUND') {
          this.builtInParts.cutOutDisposalsCustomSettings = {
            width: 135,
            depth: 135
          };
        }

        if (this.builtInParts.cutOutDisposalsType === 'CUSTOM_SQUARE') {
          this.builtInParts.cutOutDisposalsCustomSettings = {
            width: 162,
            depth: 162
          };
        }
      }

      return this.builtInParts.cutOutDisposalsCustomSettings;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "paperTowelDispensers", {
    get: function get() {
      if (!this.builtInParts) {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.PaperTowelDispensers).default;
      }

      return this.reset ? false : this.builtInParts.paperTowelDispensers;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "paperTowelDispensersPosition", {
    get: function get() {
      if (this.builtInParts && this.tissueDispenser === false || this.reset) {
        return null;
      }

      var paperTowelDispensersPosition = validation_1.prepareBooleanPositions({
        partPositions: this.builtInParts && this.builtInParts.paperTowelDispensersPosition && this.builtInParts.paperTowelDispensersPosition.length > 0 ? this.builtInParts.paperTowelDispensersPosition : [false],
        qty: this.qty,
        prevQty: this.prevQty
      });
      var positions = paperTowelDispensersPosition.positions || null;
      return positions || paperTowelDispensersPosition.values;
    },
    enumerable: true,
    configurable: true
  });

  BuiltInParts.prototype.soapDispenserDefaults = function (defaults) {
    var data = this.builtInParts;

    if (data) {
      var props = {
        drillHoleAtBackEnabled: this.plateBuilder && this.plateBuilder.calc.isDrillHoleAtBackEnabled() || false,
        qty: this.qty,
        prevQty: this.prevQty,
        plateBuilder: this.plateBuilder,
        isRound: this.trough && this.trough.round || this.trough && this.trough.oval ? true : false
      };

      if (data.soapDispenserHole && props) {
        return validation_1.validateSoapDispenser(data, defaults || this.default, props);
      }
    }

    return;
  };

  Object.defineProperty(BuiltInParts.prototype, "soapDispenserHole", {
    get: function get() {
      if (this.isVariusMedRwt) {
        return 'without';
      }

      if (!this.builtInParts) {
        var defaults = this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.SoapDispenserHole);
        return defaults && defaults.default || null;
      }

      return this.builtInParts.soapDispenserHole;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "soapDispenserHolePositions", {
    get: function get() {
      if (this.isNewVariusMedRwt) {
        return null;
      }

      var defaults = this.soapDispenserDefaults();

      if (this.builtInParts && defaults && !validation_1.isInstanceOfError(defaults)) {
        return defaults.soapDispenserHolePositions.values;
      }

      if (!this.builtInParts) {
        return defaults && !validation_1.isInstanceOfError(defaults) && defaults.soapDispenserHolePositions.values || this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.SoapDispenserHolePositions).default;
      }

      return this.builtInParts.soapDispenserHolePositions;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "tapHole", {
    get: function get() {
      if (this.isVariusMedRwt) {
        return false;
      }

      if (!this.builtInParts) {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.TapHole).default;
      }

      return this.builtInParts.tapHole;
    },
    enumerable: true,
    configurable: true
  });

  BuiltInParts.prototype.tapHoleDefaults = function (defaults) {
    var data = this.builtInParts;

    if (data) {
      // const spacings = this.plateBuilder && this.plateBuilder.calc.spaceSizes();
      var props = {
        drillHoleAtBackEnabled: this.plateBuilder && this.plateBuilder.calc.isDrillHoleAtBackEnabled() || false,
        qty: this.qty,
        prevQty: this.prevQty,
        plateBuilder: this.plateBuilder,
        isRound: this.trough && this.trough.round || this.trough && this.trough.oval ? true : false
      };

      if (data.tapHole && props) {
        return validation_1.validateTapHole(data, defaults || this.default, props);
      }
    }

    return;
  };

  Object.defineProperty(BuiltInParts.prototype, "tapHolePositions", {
    get: function get() {
      if (this.isNewVariusMedRwt || this.isVariusMedRwt) {
        return null;
      }

      var defaults = this.tapHoleDefaults();

      if (this.builtInParts && defaults && !validation_1.isInstanceOfError(defaults)) {
        return defaults.tapHolePositions.values;
      }

      if (!this.builtInParts) {
        return defaults && !validation_1.isInstanceOfError(defaults) && defaults.tapHolePositions.values || this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.TapHolePositions).default;
      }

      return this.builtInParts.tapHolePositions;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "tissueDispenser", {
    get: function get() {
      if (!this.builtInParts) {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.TissueDispenser).default;
      }

      if ((this.isNewVariusMed || this.isNewVariusMed) && this.builtInParts.tissueDispenser) {
        return false;
      }

      return this.reset ? false : this.builtInParts.tissueDispenser;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "tissueDispenserPosition", {
    get: function get() {
      if ((this.isNewVariusMed || this.isNewVariusMed) && this.builtInParts && this.builtInParts.tissueDispenser) {
        return null;
      }

      if (this.builtInParts && this.tissueDispenser === false || this.reset) {
        return null;
      }

      var tissueDispenserPosition = validation_1.prepareBooleanPositions({
        partPositions: !this.reset && this.builtInParts && this.builtInParts.tissueDispenserPosition && this.builtInParts.tissueDispenserPosition.length > 0 ? this.builtInParts.tissueDispenserPosition : [false],
        qty: this.qty,
        prevQty: this.prevQty
      });
      var positions = tissueDispenserPosition.positions || null;
      return validation_1.transformStringToBoolean(positions || tissueDispenserPosition.values); // I thought this provided the values for positions, but it didn't make a difference? weird...
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "towelRail", {
    get: function get() {
      if (!this.builtInParts || this.apronBackSplash && this.apronBackSplash.apron === 'without') {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.TowelRail).default;
      }

      if ((this.isNewVariusMed || this.isNewVariusMed) && this.builtInParts.tissueDispenser) {
        return false;
      }

      return this.builtInParts.towelRail;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "towelRailPosition", {
    get: function get() {
      if (!this.builtInParts || !this.towelRail) {
        return this.getDefault(configuration_1.ConfigurationKeys.BuiltInParts, BuiltInPartsKeys.TowelRailPosition).default;
      }

      if ((this.isNewVariusMed || this.isNewVariusMed) && this.builtInParts.tissueDispenser) {
        return null;
      }

      return this.builtInParts.towelRailPosition;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "cutOutDisposalsType", {
    get: function get() {
      if (!this.builtInParts || this.builtInParts && !this.cutOutDisposals || this.reset) {
        return null;
      }

      return this.builtInParts.cutOutDisposalsType;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BuiltInParts.prototype, "cutOutDisposalsApronRequired", {
    get: function get() {
      if (!this.builtInParts || this.builtInParts && !this.cutOutDisposals || this.reset) {
        return true; // FIXME... should be getting the default really, just running into typescript errors atm
      }

      return this.builtInParts.cutOutDisposalsApronRequired;
    },
    enumerable: true,
    configurable: true
  });
  return BuiltInParts;
}(configuration_1.Configuration);

exports.BuiltInParts = BuiltInParts;